import React from 'react';
import { StyledWrapper } from './MainTemplate-styles';

const MainTemplate = ({ children }) => {
	return <StyledWrapper>{children}</StyledWrapper>;
};

export default MainTemplate;
